import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Modal from 'components/ui/modal';
import Form from 'components/form';
import Input from 'components/form/Input';
import DateInput from 'components/form/DateInput';
import Button from 'components/common/Button';
import { useQuery } from 'react-apollo';
import { GET_SCHOOLS } from 'graphql/student_college';
import Select from 'components/form/Select';

const FormItem = Form.FormItem;

const styles = theme => ({
  root: {
    minWidth: 360,
    [theme.breakpoints.down('sm')]: {
      minWidth: 30
    }
  },
  input: {
    marginBottom: theme.spacing(3),
  },
});

const AddUniversity = ({
  onClose,
  onSubmit,
  data,
  form: { getFieldDecorator, validateFields },
  classes,
  user
}) => {
  const { data: schools } = useQuery(GET_SCHOOLS, {
    variables: {
      student_sub: user.sub,
    },
  });

  const handleSubmit = () => {
    return validateFields().then(onSubmit);
  };

  return (
    <Modal
      fullWidth
      open
      maxWidth="sm"
      title={data.id ? 'Edit University' : 'Add University'}
      actions={[
        <Button variant="text" onClick={onClose}>
          Cancel
        </Button>,
        <Button variant="contained" color="primary" onClick={handleSubmit}>
          {data.id ? 'Update University' : 'Add University'}
        </Button>,
      ]}
    >
      <Form className={classes.root}>
        <FormItem>
          {getFieldDecorator('schools', {
            initialValue: data?.schools,
            rules: [{ required: true, message: 'Please select University' }],
          })(
            <Select
              debounceTimeout={300}
              options={schools?.student_college.map((i) => ({
                label: i.college_name,
                value: i.college_id,
              }))}
              placeholder="Start typing university name"
              label="Schools"

            />,
          )}
        </FormItem>
        <FormItem>
          {getFieldDecorator('due_date', {
            initialValue: data.id ? data.due_date : null,
            rules: [{ required: true, message: 'Please select due date' }],
          })(
            <DateInput
              fullWidth
              inputVariant="outlined"
              format="MMM DD, YYYY"
              label="Due date"
              minDate={new Date()}
            />,
          )}
        </FormItem>
      </Form>
    </Modal>
  );
};

export default Form.create()(
  withStyles(styles)(AddUniversity)
);
